export const BackButton = () => <div className='w-5 h-5 bg-tertiary rounded-sm animate-pulse' />;
